"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSumLineWidth = void 0;
var useSumLineWidth = exports.useSumLineWidth = function useSumLineWidth() {
  return function () {
    var line = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var limit = arguments.length > 1 ? arguments[1] : undefined;
    if (limit) {
      line = line.slice(0, limit);
    }
    return line.reduce(function (result, current) {
      return result + current;
    }, 0);
  };
};